function Why() {
  return (
    <section className="why">
      <h2>Why Choose Codeion?</h2>

      <div className="why-grid">
        <div className="why-card">
          <h3>Industry Mentors</h3>
          <p>Learn directly from professionals.</p>
        </div>

        <div className="why-card">
          <h3>Real Projects</h3>
          <p>Work on real-world projects.</p>
        </div>

        <div className="why-card">
          <h3>Career Support</h3>
          <p>Resume & interview guidance.</p>
        </div>

        <div className="why-card">
          <h3>Job Ready Skills</h3>
          <p>Become industry ready.</p>
        </div>
      </div>
    </section>
  );
}

export default Why;